import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

export const VideoContainer = styled.div`
  height: calc(100% + 5px);
  display: flex;
  overflow: hidden;
  height: 100%;
  width: 100%;
  max-height: 520px;
  margin-bottom: -10px;
  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    height: 100%;
    z-index: 1;
    width: 100%;
    display: block;
    background: linear-gradient(
      0deg,
      rgba(16, 16, 16, 0.7) 0%,
      rgba(16, 16, 16, 0) 76.1%,
      rgba(16, 16, 16, 0) 100%
    );
  }
`;

export const VideoHero = styled.video`
  flex-shrink: 0;
  object-fit: cover;
  width: 100%;
`;

export const ControlContainer = styled.span`
  position: absolute;
  right: 40px;
  z-index: 3;
  bottom: 8px;
  cursor: pointer;
  display: block;

  ${breakpoints.lg} {
    right: 122px;
  }
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    padding: 6px;
    width: 16px;
    height: 16px;
    transition: background-color 0.2s ease-in-out;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    backdrop-filter: blur(1.5px);
  }

  &:hover {
    cursor: pointer;
    svg {
      background-color: rgba(255, 255, 255, 0.3);
      transition: background-color 0.2s ease-in-out;
    }
  }
`;
